import { useEffect, useRef, useState } from "react";

/**
 * Detects whether a text element's content overflows its container
 * (i.e., is being truncated by CSS line-clamp or overflow:hidden).
 *
 * Uses ResizeObserver for reliable detection after layout, and
 * re-checks when the text content changes.
 */
export function useTextOverflow(text: string) {
  const ref = useRef<HTMLParagraphElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => {
      setIsOverflowing(el.scrollHeight > el.clientHeight);
    };

    check();

    const observer = new ResizeObserver(check);
    observer.observe(el);

    return () => {
      observer.disconnect();
    };
  }, [text]);

  return { ref, isOverflowing };
}
